/**
 * @file Component to assemble other components to construct a view.
 * @author Tom Verschoore de la Houssaije
 */
import * as tslib_1 from "tslib";
import { OnInit, OnDestroy } from '@angular/core';
import { AbstractView } from '../helpers/abstract-view';
import { ListContainerComponent } from '../list-container/list-container.component';
import { RoutesService } from '../../routes.service';
/**
 * Abstract base class to assemble other components to construct a view.
 * @export
 * @abstract
 * @class DataViewBase
 * @extends {AbstractView}
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
var DataViewBase = /** @class */ (function (_super) {
    tslib_1.__extends(DataViewBase, _super);
    /**
     * Constucts a DataViewComponent component.
     * @param configurationsService The configuration service.
     * @param router The router
     * @param route The activated route.
     */
    function DataViewBase(router, route, breezeService, dialogService, alertsService, translateService) {
        var _this = _super.call(this, router, route, breezeService, dialogService, alertsService, translateService) || this;
        // Set configurations to be always defined. Do not use *ngIf because of nested RouterOutlet.
        /** Property where the loaded configuration is divided in logical keys for easy access in the template. */
        _this.configurations = {};
        /** Handle to hold the last created entity. Is used in creation sequence. */
        _this.lastCreated = null;
        return _this;
    }
    /**
     * Is called directly after the creation of this component
     */
    DataViewBase.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.subscriptionPool.add(this.router.routerState.root.queryParams.subscribe(function (params) {
            var id = params['new-result'];
            if (id) {
                var queryParams_1 = {};
                Object.keys(params).filter(function (key) { return key !== 'new-result'; }).forEach(function (key) {
                    queryParams_1[key] = params[key];
                });
                _this.router.navigate([], { queryParams: queryParams_1 }).then(function (value) {
                    if (_this.lastCreated && _this.dataList && _this.dataList.instance) {
                        _this.dataList.instance.items.splice(0, 0, _this.lastCreated);
                        _this.dataList.instance.select(_this.lastCreated);
                    }
                    _this.lastCreated = null;
                }).catch(function (value) {
                    _this.lastCreated = null;
                });
                return;
            }
            id = params['delete-result'];
            if (id) {
                var queryParams_2 = {};
                Object.keys(params).filter(function (key) { return key !== 'delete-result'; }).forEach(function (key) {
                    queryParams_2[key] = params[key];
                });
                RoutesService.navigateBack(_this.router, _this.route, queryParams_2).then(function (value) {
                    if (_this.dataList && _this.dataList.instance) {
                        _this.dataList.instance.removeItem(id);
                    }
                }).catch(function (value) {
                    if (_this.dataList && _this.dataList.instance) {
                        _this.dataList.instance.removeItem(id);
                    }
                });
                return;
            }
        }));
    };
    /**
     * Called when closed event is triggered on sidebar.
     * @param subject The reason of closing the sidebar.
     */
    DataViewBase.prototype.sidebarIsClosing = function (subject) {
        this.dataList.instance.deselect(this.dataList.instance.current);
    };
    /**
     * Is called by the ListComponent.entityCreated event and is used to navigate to the details of the new entity.
     * @param item The item created.
     * @returns True when a route for displaying the new entity in detail, otherwise false.
     */
    DataViewBase.prototype.navigateToNew = function (item) {
        var _this = this;
        if (!item) {
            return false;
        }
        var routes = this.configuration.routes;
        if (!routes) {
            return false;
        }
        var self = this;
        if (routes.find(function (route) {
            if (route.name === 'New') {
                if (route.path.includes(':id')) {
                    var key_1 = '';
                    item.entityType.keyProperties.forEach(function (property) {
                        key_1 += item[property.name].toString();
                    });
                    _this.lastCreated = item;
                    _this.router.navigate([route.path.replace(':id', key_1)], { relativeTo: self.route });
                    return true;
                }
                _this.lastCreated = item;
                _this.router.navigate([route.path], { relativeTo: self.route });
                return true;
            }
            return false;
        })) {
            return true;
        }
        return false;
    };
    /**
     * Is called after the block name is set and the configuration is loaded.
     */
    DataViewBase.prototype.afterInitialize = function () {
        // Improve: use configuration name instead of the component order in the configuration
        this.configurations = {
            insights: this.findChildConfiguration('insights'),
            list: this.findChildComponent('list'),
        };
    };
    return DataViewBase;
}(AbstractView));
export { DataViewBase };
